// src/utils/numbers.ts
const nfCache = new Map<string, Intl.NumberFormat>();

function getNF(locale: string) {
  if (!nfCache.has(locale)) nfCache.set(locale, new Intl.NumberFormat(locale));
  return nfCache.get(locale)!;
}

export function formatCurrency(amount: number | undefined | null, currency = 'AMD', locale = 'ru-RU') {
  const v = Number(amount) || 0;
  const nf = getNF(locale);
  return `${nf.format(v)} ${currency}`;
}
